import React, { useCallback, useContext, useMemo, useState } from "react";
import { intl, LanguageEnum } from "dmsbasereact";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import { DmsHelpCenter } from "./index.js";
import { LanguageBaseContext } from "dmsbasereact";

import { resolveManualSlug } from "../../utils/manualRouteResolver";

const getLanguageOrDefault = (language) => language || LanguageEnum.PT_BR;

export const DmsHelpCenterButton = () => {
  const location = useLocation();
  const { language } = useContext(LanguageBaseContext);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [stateSummary, setStateSummary] = useState({
    isOffline: false,
    fromCache: false,
    isStale: false,
  });

  const slug = useMemo(
    () => resolveManualSlug(location.pathname),
    [location.pathname]
  );

  const handleStateChange = useCallback((state) => {
    setStateSummary((prev) => ({
      ...prev,
      ...state,
    }));
  }, []);

  const badgeColor = useMemo(() => {
    if (stateSummary.isOffline) {
      return stateSummary.isStale ? "error" : "warning";
    }
    if (stateSummary.isStale) {
      return "secondary";
    }
    return "primary";
  }, [stateSummary.isOffline, stateSummary.isStale]);

  const showBadge = stateSummary.isOffline || stateSummary.isStale;

  const tooltipLabel = intl.get("helpCenter.tooltip").d("Central de Ajuda");

  const button = (
    <Tooltip title={tooltipLabel}>
      <IconButton
        color="inherit"
        size="large"
        onClick={() => setIsOverlayOpen(true)}
        data-testid="help-center-button"
        aria-label={tooltipLabel}
      >
        <HelpOutlineIcon aria-hidden="true" />
      </IconButton>
    </Tooltip>
  );

  return (
    <>
      <Badge
        color={badgeColor}
        variant="dot"
        overlap="circular"
        invisible={!showBadge}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        slotProps={{ badge: { "aria-hidden": true } }}
      >
        {button}
      </Badge>
      <DmsHelpCenter
        open={isOverlayOpen}
        onClose={() => setIsOverlayOpen(false)}
        route={location.pathname}
        slug={slug}
        language={getLanguageOrDefault(language)}
        onStateChange={handleStateChange}
      />
    </>
  );
};